export let toggleLoading = (toggle) => {
  return (dispatch) => {
    dispatch({
      type: "APP_LOADING",
      payload: toggle,
    });
  };
};

export let updateProgress = (ReducerType, payload) => {
  return (dispatch) => {
    let progress = setInterval(() => {
      console.log(JSON.stringify(payload));
      if (payload.value === 80) clearInterval(progress);
      payload = {
        ...payload,
        value: payload.value >= 80 ? 80 : payload.value + 5,
      };
      dispatch({
        type: ReducerType,
        payload,
      });
    }, 80);
  };
};



// WEBPACK FOOTER //
// ./src/services/appActions.js